import React, {useContext, useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import {registrationCn} from '../index';
import {RegContext} from "../RegContext";
import {getLang} from "../../../../common";
import {getRules} from "../../../../api/api";
import Modal from "../../modal";

const RegWrapper = ({brandName, lang, promocode, langId, translationForReg, title, subtitle, children}) => {
	const [companyRules, setCompanyRules] = useState('')
	const [privacyPolicy, setPrivacyPolicy] = useState('')
	const [companyRulesOpen, setCompanyRulesOpen] = useState(false)
	const [privacyPolicyOpen, setPrivacyPolicyOpen] = useState(false)

	const {state} = useContext(RegContext);

	useEffect(() => {
		initRules()
	}, [])

	const initRules = () => {
		const getData = async (key, setter) => {
			const response = await getRules(promocode, langId, 0, key)
			if (response.data.code !== 0) {
				return false
			}
			setter(response.data.result[key])
		}
		getData('company_rules', setCompanyRules)
		getData('privacy_policy', setPrivacyPolicy)
	}

	const modalHandler = () => {
		if (!companyRulesOpen) {
			setPrivacyPolicyOpen(false)
			return
		}
		setCompanyRulesOpen(false)
	}

	return (
		<>
			<Helmet>
				<script src='https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit' async defer/>
			</Helmet>
			<div className={registrationCn()}>
				<div className={registrationCn('Title')}>{title}</div>
				<div className={registrationCn('Subtitle')}>{subtitle}</div>
				{children}
				{state.step !== 3 ? (
					<div className={`${registrationCn('Rules')} ${registrationCn(`Rules_${lang}`)}`}>
						{getLang(translationForReg, brandName, lang, 'disclaimerText1')}
						<a onClick={() => setCompanyRulesOpen(true)}>{getLang(translationForReg, brandName, lang, 'disclaimerRules')}</a>
						{getLang(translationForReg, brandName, lang, 'disclaimerText2')}
						<a onClick={() => setPrivacyPolicyOpen(true)}>{getLang(translationForReg, brandName, lang, 'disclaimerPrivacyPolicy')}</a>
						{getLang(translationForReg, brandName, lang, 'disclaimerText3')}
					</div>
				) : null}
			</div>
			{state.step !== 3 ? (
				<>
					<Modal onClose={modalHandler} className='Registration-modal' visible={companyRulesOpen} title={getLang(translationForReg, brandName, lang, 'betAcceptanceRules')}>
						<div className='static-html' dangerouslySetInnerHTML={{__html: companyRules}}/>
					</Modal>
					<Modal onClose={modalHandler} className='Registration-modal' visible={privacyPolicyOpen} title={getLang(translationForReg, brandName, lang, 'privacyPolicy')}>
						<div className='static-html' dangerouslySetInnerHTML={{__html: privacyPolicy}}/>
					</Modal>
				</>
			) : null}
		</>
	);

};

export default RegWrapper;
